import React, { useEffect, useState, useCallback } from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Typography,
  Button,
  Box,
  IconButton,
  //Checkbox,
  FormControlLabel,
} from "@mui/material";
import Checkbox from '@material-ui/core/Checkbox';
import {
  Grid,
  InputLabel,
  Select,
  MenuItem,
  FormControl,
} from "@material-ui/core";
import { BootstrapInput } from "../../../Utilities/utility";
import { useSelector } from "react-redux";
import CloseIcon from "@mui/icons-material/Close";
import UploadDrawingDialog from "./upload-drawing";
import {
  getMLFBSeriesList,
  getDBTypeListBasedOnDbSeries,
  getVariantsList,
  getCountriesList,
  getNoOfWaysList1,
  getNoOfWaysList2,
  drawingUpload,
  IsMLFBExist,
  getPreviewDrawing,
} from "../../../redux/API/api_standardMLFB";
import Loading from "../../../components/Loading/Loading";
import SnackbarCustom from "../../../components/Snackbar/Snackbar";

const standardMlfbDialog = React.memo(
  ({ open, onClose, onSave, onUpdate, userToEdit }) => {
    const [error, setError] = useState("");
    const [errors, setErrors] = useState({});
    const [MLFBId, setMLFBId] = useState("");
    const [alertType, setAlertType] = useState("");
    const [dbSeriesDropdown, setDBSeriesDropdown] = useState();
    const [openDialog, setOpenDialog] = useState(false);
    const [dbTypeDropdown, setDBTypeDropdown] = useState("");
    const [varientDropdown, setVarientDropdown] = useState("");
    const [countryDropdown, setCountryDropdown] = useState("INDIA");
    const [noOfWaysDropdown, setNoOfWaysDropdown] = useState("");
    const [horiVerticalDropdown, setHoriVerticalDropdown] = useState("");
    const [dbSeriesData, setDBSeriesData] = useState([]);
    const [isLoader, setIsLoader] = useState(false);
    const [loaderUploading, setUploading] = useState(false);
    const [dbSeriesId, setDBSeriesId] = useState("");
    const [dbSeriesName, setDBseriesName] = useState("");
    const [dbTypeName, setDBTypeName] = useState("");
    const [dbTypeData, setDBTypeData] = useState([]);
    const [varientData, setVarientData] = useState([]);
    const [countryData, setCountryData] = useState([]);
    const [noOfWayData, setNoOfWayData] = useState([]);
    const [horiVertical, setHoriVertical] = useState([]);
    const UID = useSelector((state) => state.saveUserIdReducer);
    const userdetails = useSelector(
      (state) => state.storeUserDetailsReducer.userData
    );
    const siteToken = useSelector((state) => state.saveTokenReducer);
    const [opend, setOpend] = useState(false);
    const azureToken = useSelector((state) => state.saveAzureTokenReducer);
    const [snackMessage, setSnackMessage] = useState("");
    const [horiVerticalName, setHoriVerticalName] = useState("");
    const [variantName, setVariantName] = useState("");
    const [isEdit, setIsEdit] = useState(true);
    const [previewDrawing, setPreviewDrawing] = useState("");
    const [isExitMsg, setIsExitMsg] = useState(false);
    const [checkedIn, setCheckedIn] = useState(false);

    const [formData, setFormData] = useState({
      txtMLFB: "",
      txtDescription: "",
      txtItemNO: "",
      txtDrawingNo: "",
      NoOfWays: "",
      txtMRP: "",
      txtCost: "",
      UserID: "",
      DBSeries: "",
      DBType: "",
      Variants: "",
      Countries: "",
      DBSeriesId: "",
      VariantsId: "",
      CountriesId: "",
      NoOfWaysId: "",
      DBTypeId: "",
      horiVerticalId: "",
      dbSeriesName: "",
      dbTypeName: "",
      variantName: "",
      countryName: "",
      noOfWaysName: "",
      horiVerticalName: "",
      isActive: checkedIn,
    });

    useEffect(() => {
      if (userToEdit?.editStdMlfb?.isActive !== undefined) {
        setCheckedIn(userToEdit?.editStdMlfb?.isActive)
      } else {
        setCheckedIn(false)
      }
      setError("");
      setErrors({});


      setDBseriesName("");
      setMLFBId(userToEdit?.editStdMlfb?.standardMLFBID);
      setDBSeriesDropdown();
      setDBTypeDropdown(0);
      setVarientDropdown(0);
      getDbSeriesDropDownValue();

      if (userToEdit?.editStdMlfb?.standardMLFBID) {
        setIsEdit(false);
        DBSeriesDropDownChange(userToEdit?.editStdMlfb?.dbSeriesId);
        getNoOfWay1DropdownList(userToEdit?.editStdMlfb?.dbSeriesId);
        getNoOfWay2DropdownList(userToEdit?.editStdMlfb?.dbTypeID);
      }
      getVarientDropdownList();
      getCountryDropdownList();
      setDBTypeName("");
      setDBTypeData([""]);
      /// setDBSeriesData([""]);
      setVarientData([""]);
      setNoOfWayData([""]);
      setCountryData([""]);
      setVarientData([""]);
      //setDBTypeName("");
      //onPreview(MLFBId);

      //setError("");
      setFormData({
        txtMLFB: userToEdit?.editStdMlfb?.mlfb || "",
        txtDescription: userToEdit?.editStdMlfb?.description || "",
        txtItemNO: userToEdit?.editStdMlfb?.itemno || "",
        txtDrawingNo: userToEdit?.editStdMlfb?.drawingNo || "",
        StandardMLFBID: userToEdit?.editStdMlfb?.standardMLFBID || "",
        txtMRP: userToEdit?.editStdMlfb?.mrp || "",
        txtCost: userToEdit?.editStdMlfb?.cost || "",
        UserID: userdetails.userId || "",
        DBSeries: userToEdit?.editStdMlfb?.dbSeriesName || "",
        NoOfWays: userToEdit?.editStdMlfb?.noOfWaysName || "",
        DBType: userToEdit?.editStdMlfb?.dbTypeName || "",
        Variants: userToEdit?.editStdMlfb?.variantName || "",
        Countries: userToEdit?.editStdMlfb?.countryShortName || "",
        DBSeriesId: userToEdit?.editStdMlfb?.dbSeriesId || "",
        NoOfWaysId: userToEdit?.editStdMlfb?.noOfWaysId || "",
        CountriesId: userToEdit?.editStdMlfb?.countryId || "",
        DBTypeId: userToEdit?.editStdMlfb?.dbTypeID || "",
        VariantsId: userToEdit?.editStdMlfb?.variantId || "",
        horiVerticalId: horiVerticalDropdown || "",
        dbSeriesName: userToEdit?.editStdMlfb?.dbSeriesName || "",
        dbTypeName: userToEdit?.editStdMlfb?.dbTypeName || "",
        variantName: userToEdit?.editStdMlfb?.variantName || "",
        countryName: userToEdit?.editStdMlfb?.countryName || "",
        noOfWaysName: userToEdit?.editStdMlfb?.noOfWaysName || "",
        horiVerticalName: horiVerticalName || "",
        isActive: checkedIn ? true : false,
      });
      console.log("horiVerticalName", horiVerticalName);
    }, [userToEdit]);

    const handleSnackOpen = (text, type) => {
      setSnackMessage(text);
      setAlertType(type);
      setOpend(true);
    };

    const handleClose = (e) => {
      setOpend(false);
    };

    const DBSeriesDropDownChange = (e) => {
      const selectedId = e;
      if (dbSeriesData?.length > 0) {
        const selectObject = dbSeriesData.find(
          (item) => item.dbSeriesId === selectedId
        );
        setFormData({
          ...formData,
          DBSeries: selectObject.dbSeriesId,
          DBSeriesId: selectObject.dbSeriesId,
          dbSeriesName: selectObject.dbSeriesName,
        });
        setDBseriesName(selectObject.dbSeriesName);
        setDBSeriesId(selectObject.dbSeriesId);
        getDbTypeDropDownValueBasedOnDBSeries(
          selectObject.dbSeriesName,
          selectedId
        );
      }
      setDBTypeData([""]);
      setVarientData([""]);
      setCountryData([""]);
      setNoOfWayData([""]);
      setErrors(errors?.dbSeriesName);
    };

    const DbTypeDropDownChange = (e) => {
      getCountryDropdownList();
      getVarientDropdownList();
      const selectedId = e.target.value;
      const selectObject = dbTypeData.find(
        (item) => item.dbTypeID === selectedId
      );

      setDBTypeDropdown(selectedId);
      setDBTypeName(selectObject.dbTypeName);
      if (dbSeriesName == "8GB0" && selectObject.dbTypeName) {
        getNoOfWay1DropdownList(dbSeriesId);
      } else if (dbSeriesName == "8GB31" && selectObject.dbTypeName) {
        getNoOfWay2DropdownList(selectedId);
      } else if (
        (dbSeriesName == "8GB32" && selectObject.dbTypeName) ||
        (dbSeriesName == "8GB30" && selectObject.dbTypeName)
      ) {
        getNoOfWay1DropdownList(dbSeriesId);
      }

      // logic for mlfb desc
      let mlfb = "";
      if (selectObject.dbTypeName.includes("5")) {
        mlfb = dbSeriesName + selectObject.dbTypeName[0];
      } else {
        mlfb = dbSeriesName + selectObject.dbTypeName[0] + "RC";
      }

      if (
        selectObject.dbTypeName.includes("2") ||
        selectObject.dbTypeName.includes("4")
      ) {
        setHoriVerticalName("");
      }
      setFormData({
        ...formData,
        DBType: selectObject.dbTypeID,
        DBTypeId: selectObject.dbTypeID,
        CountriesId: 1,
        txtMLFB: mlfb,
        dbTypeName: selectObject.dbTypeName,
      });
      setErrors({});
    };

    const varientDropDownChange = (e) => {
      setVarientDropdown(e.target.value);
      setHoriVerticalName("");
      const selectObject = varientData.find(
        (item) => item.variantId === e.target.value
      );

      setVariantName(selectObject.variantName);
      let mlfb = "";
      mlfb =
        dbSeriesName +
        dbTypeName[0] +
        selectObject.variantName[0] +
        selectObject.variantName[1] +
        "RC";

      setFormData({
        ...formData,
        Variants: e.target.value,
        VariantsId: e.target.value,
        txtMLFB: mlfb,
        variantName: selectObject.variantName,
      });
      setErrors({});
    };

    const countryDropDownChange = (e) => {
      const selectObject = countryData.find(
        (item) => item.countryId === e.target.value
      );
      // setCountryName(selectObject.Countries)
      setCountryDropdown(e.target.value);
      setFormData({
        ...formData,
        Countries: e.target.value,
        CountriesId: e.target.value,
        countryName: selectObject.countryName,
      });
      setErrors({});
    };

    const noOfWaysDropDownChange = (e) => {
      setNoOfWaysDropdown(e.target.value);

      const selectObject = noOfWayData.find(
        (item) => item.noOfWaysId === e.target.value
      );
      let mlfb = "";
      if (horiVerticalName != "") {
        mlfb =
          dbSeriesName +
          dbTypeName[0] +
          horiVerticalName[0] +
          selectObject.noOfWaysName[0] +
          selectObject.noOfWaysName[1] +
          "RC";
      } else if (variantName != "") {
        mlfb =
          dbSeriesName +
          dbTypeName[0] +
          variantName[0] +
          variantName[1] +
          "RC" +
          selectObject.noOfWaysName[0] +
          selectObject.noOfWaysName[1];
      } else {
        mlfb =
          dbSeriesName +
          dbTypeName[0] +
          selectObject.noOfWaysName[0] +
          selectObject.noOfWaysName[1] +
          "RC";
      }

      setFormData({
        ...formData,
        NoOfWays: e.target.value,
        NoOfWaysId: e.target.value,
        txtMLFB: mlfb,
        noOfWaysName: selectObject.noOfWaysName,
      });
      setErrors({});
    };

    const horiVerticalDropDownChange = (e) => {
      setHoriVerticalDropdown(e.target.value);
      let data = e.target.value == 1 ? "Vertical" : "Horizontal";
      if (e.target.value == "1") {
        setHoriVerticalName("Vertical");
      }
      if (e.target.value == "2") {
        setHoriVerticalName("Horizontal");
      }

      let mlfb = "";
      mlfb = dbSeriesName + dbTypeName[0] + data[0] + "RC";
      console.log("horiVerticalName", horiVerticalName);
      console.log("Horiverticaldropdown", horiVerticalDropdown);
      setFormData({
        ...formData,
        UserID: e.target.value,
        horiVerticalId: e.target.value,
        txtMLFB: mlfb,
        horiVerticalName: data,
      });
      setErrors({});
    };

    function getDbSeriesDropDownValue() {
      setIsLoader(true);
      getMLFBSeriesList(
        siteToken,
        azureToken.token,
        UID.id,
        userdetails.userEmail,
        userdetails.gid,
        userdetails.roleName,
        userdetails.roleId
      )
        .then((response) => {
          console.log("MLFB data", response);
          setDBSeriesData(response);
          setIsLoader(false);
        })
        .catch((error) => {
          console.log("Error: " + error, "error");
          setIsLoader(false);
        });
    }

    function getDbTypeDropDownValueBasedOnDBSeries(name, id) {
      setIsLoader(true);
      getDBTypeListBasedOnDbSeries(
        siteToken,
        azureToken.token,
        UID.id,
        userdetails.userEmail,
        userdetails.gid,
        userdetails.roleName,
        userdetails.roleId,
        name,
        id
      )
        .then((response) => {
          console.log("DBType data", response);
          setDBTypeData(response);
          setIsLoader(false);
        })
        .catch((error) => {
          console.log("Error: " + error, "error");
          setIsLoader(false);
        });
    }

    function getVarientDropdownList() {
      setIsLoader(true);
      getVariantsList(
        siteToken,
        azureToken.token,
        UID.id,
        userdetails.userEmail,
        userdetails.gid,
        userdetails.roleName,
        userdetails.roleId
      )
        .then((response) => {
          console.log("DBType data", response);
          setVarientData(response);
          setIsLoader(false);
        })
        .catch((error) => {
          console.log("Error: " + error, "error");
          setIsLoader(false);
        });
    }

    function getCountryDropdownList() {
      setIsLoader(true);
      getCountriesList(
        siteToken,
        azureToken.token,
        UID.id,
        userdetails.userEmail,
        userdetails.gid,
        userdetails.roleName,
        userdetails.roleId
      )
        .then((response) => {
          console.log("DBType data", response);
          setCountryData(response);
        })
        .catch((error) => {
          console.log("Error: " + error, "error");
        })
        .finally(() => {
          setIsLoader(false);
        });
    }

    function getNoOfWay1DropdownList(value) {
      setIsLoader(true);
      getNoOfWaysList1(
        siteToken,
        azureToken.token,
        UID.id,
        userdetails.userEmail,
        userdetails.gid,
        userdetails.roleName,
        userdetails.roleId,
        value
      )
        .then((response) => {
          console.log("No Of Ways", response);
          setNoOfWayData(response);
          setIsLoader(false);
        })
        .catch((error) => {
          console.log("Error: " + error, "error");
          setIsLoader(false);
        });
    }
    function getNoOfWay2DropdownList(value) {
      setIsLoader(true);
      getNoOfWaysList2(
        siteToken,
        azureToken.token,
        UID.id,
        userdetails.userEmail,
        userdetails.gid,
        userdetails.roleName,
        userdetails.roleId,
        value
      )
        .then((response) => {
          console.log("No Of Ways", response);
          setNoOfWayData(response);
          setIsLoader(false);
        })
        .catch((error) => {
          console.log("Error: " + error, "error");
          setIsLoader(false);
        });
    }

    function isMLFBExist(mlfbId) {
      setIsLoader(true);
      IsMLFBExist(
        siteToken,
        azureToken.token,
        UID.id,
        userdetails.userEmail,
        userdetails.gid,
        userdetails.roleName,
        userdetails.roleId,
        mlfbId
      )
        .then((response) => {
          if (response.response) {
            setIsExitMsg(response.response);
            //handleSnackOpen(response.responseMsg, "error");
            setIsLoader(false);
          } else {
            onSave(formData);
            setIsLoader(false);
          }
        })
        .catch((error) => {
          handleSnackOpen("Exception : " + error, "error");
          setIsLoader(false);
        });
    }

    const handleChange = (e) => {

      setFormData({ ...formData, [e.target.name]: e.target.value });
      setError("");
      setErrors({});
    };

    const handleSave = (e) => {
      const costPattern = /^\d+(?:\.\d{0,2})?$/;
      const mrpPattern = /^\d+(?:\.\d{0,2})?$/;
      const newError = {};
      setErrors({});
      setIsExitMsg(false);


      if (!formData.dbSeriesName && !userToEdit.editStdMlfb) {
        newError.dbSeriesName = "DB Series is required !!";
      }

      if (!formData.dbTypeName && !userToEdit.editStdMlfb) {
        newError.dbTypeName = "DB Type is required !!";
      }
      if (!formData.noOfWaysName && !userToEdit.editStdMlfb) {
        newError.noOfWaysName = "No Of Ways is required !!";
      }

      if (formData.dbSeriesName == "8GB32" && dbTypeName) {
        if (!formData.variantName && !userToEdit.editStdMlfb) {
          newError.variantName = "Variant is required !!";
        }
      }
      if (formData.dbSeriesName === "8GB0" && formData.dbTypeName == "4-TPN") {
        if (!formData.horiVerticalName && !userToEdit.editStdMlfb) {
          newError.horiVerticalName = "Horizontal/Vertical is required !!";
        }
      }
      if (!formData.txtMLFB) {
        newError.txtMLFB = "MLFB is required !!";
      }
      // if (!formData.countryName) {
      //   newError.countryName = "Country is required !!";
      // }
      if (!formData.txtDescription) {
        newError.txtDescription = "Description is required!!";
      }

      if (!formData.txtItemNO) {
        newError.txtItemNO = "Item No is required";
      }
      if (!formData.txtMRP) {
        newError.txtMRP = "MRP No is required";
      }
      if (formData.txtMRP && !mrpPattern.test(formData.txtMRP)) {
        newError.txtMRP = "Enter number only";
      }
      if (formData.txtCost && !costPattern.test(formData.txtCost)) {
        newError.txtCost = "Enter number only";
      }
      if (isExitMsg == true && !userToEdit.editStdMlfb) {
        newError.txtMLFB = "MLFB is already exist !!";
      }

      if (Object.keys(newError).length > 0) {
        setErrors(newError);
        return;
      } else if (userToEdit?.editStdMlfb) {
        onUpdate(formData);
      } else {
        isMLFBExist(formData.txtMLFB);
      }
    };

    const handleDrawing = useCallback(() => {
      setOpenDialog(true);
    }, []);

    const onUploadDrawing = (data) => {
      setOpenDialog(false);
      setUploading(true);
      handleUploadDrawing(data);
    };

    function handleUploadDrawing(selectedFile) {
      setUploading(true);
      const formData = new FormData();
      formData.append("file", selectedFile);
      formData.append("iMLFBId", MLFBId);
      drawingUpload(
        siteToken,
        azureToken.token,
        UID.id,
        userdetails.userEmail,
        userdetails.gid,
        userdetails.roleName,
        userdetails.roleId,
        formData
      )
        .then((response) => {
          console.log(response);
          if (response.response) {
            setUploading(false);
            handleSnackOpen(response.responseMsg, "success");
          } else {
            setUploading(false);

            handleSnackOpen(
              response.responseMsgs && response.responseMsgs.length > 0
                ? response.responseMsgs
                : response.responseMsg
            );
          }
        })
        .catch((error) => {
          setUploading(false);

          handleSnackOpen("Exception in upload");
        });
    }

    // function onPreview(MLFBId) {
    //   setUploading(true);

    //   getPreviewDrawing(
    //     siteToken,
    //     azureToken.token,
    //     UID.id,
    //     userdetails.userEmail,
    //     userdetails.gid,
    //     userdetails.roleName,
    //     userdetails.roleId,
    //     MLFBId
    //   )
    //     .then((response) => {
    //       setUploading(false);
    //       const pdfUrl = response?.result || response;
    //       console.log("pdfurl", pdfUrl);
    //       pdfUrl
    //         ? window.open(pdfUrl, "_blank")
    //         : handleSnackOpen(
    //           "Error while downloading Preview Drawing.",
    //           "error"
    //         );
    //     })
    //     .catch((error) => {
    //       setUploading(false);
    //       handleSnackOpen("Error while downloading Preview Drawing.", "error");
    //     });
    // }
    const handleCheckChange = () => {
      setCheckedIn(!checkedIn)
      setFormData({
        ...formData,
        isActive: !checkedIn
      });
    }

    return (
      <>
        <SnackbarCustom
          open={opend}
          message={snackMessage}
          alertType={alertType}
          handleClose={handleClose}
        />
        <div>
          <Dialog
            disableEnforceFocus
            disableAutoFocus
            open={open}
            onClose={onClose}
            fullWidth
            maxWidth="md"
            sx={{
              "& .MuiDialog-paper": {
                width: "auto",
                minWidth: 500,
                maxWidth: "90vw",
                height: "auto",
                maxHeight: "110vh",
                padding: 2,
              },
            }}
          >
            <DialogTitle sx={{ fontWeight: "bold", textAlign: "center" }}>
              {userToEdit?.editStdMlfb
                ? "Update Standard MLFB"
                : "Create Standard MLFB"}
              <IconButton
                onClick={onClose}
                style={{ position: "absolute", right: 8, top: 8 }}
              >
                <CloseIcon />
              </IconButton>
            </DialogTitle>

            <DialogContent>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  gap: 3,
                  flexWrap: "wrap",
                }}
              >
                <Box sx={{ width: "45%" }}>
                  <Typography sx={{ fontWeight: "bold" }}>
                    DBSeries<span style={{ color: "red" }}>*</span>
                  </Typography>
                  <span>
                    <Select
                      name="dbSeriesName"
                      disabled={userToEdit.editStdMlfb}
                      value={formData.DBSeriesId}
                      onChange={(e) => DBSeriesDropDownChange(e.target.value)}
                      displayEmpty
                      fullWidth
                      required
                      input={<BootstrapInput />}
                      sx={{
                        "& .MuiMenu-paper": {
                          color: "red",
                        },
                      }}
                    >
                      {dbSeriesData?.length > 0 ? (
                        dbSeriesData?.map((data) => (
                          <MenuItem
                            key={data.dbSeriesId}
                            value={data.dbSeriesId}
                          >
                            {data.dbSeriesName}
                          </MenuItem>
                        ))
                      ) : (
                        <MenuItem disabled>Loading DB Series...</MenuItem>
                      )}
                    </Select>
                    {errors?.dbSeriesName && (
                      <Typography color="error" sx={{ textAlign: "center" }}>
                        {errors?.dbSeriesName}
                      </Typography>
                    )}
                  </span>

                  <Typography sx={{ fontWeight: "bold", mt: 2 }}>
                    DBType<span style={{ color: "red" }}>*</span>
                  </Typography>
                  <span>
                    <Select
                      name="dbTypeName"
                      disabled={userToEdit.editStdMlfb}
                      value={formData.DBTypeId}
                      onChange={DbTypeDropDownChange}
                      displayEmpty
                      fullWidth
                      input={<BootstrapInput />}
                    >
                      {dbTypeData?.length > 0 ? (
                        dbTypeData.map((data) => (
                          <MenuItem key={data.dbTypeID} value={data.dbTypeID}>
                            {data.dbTypeName}
                          </MenuItem>
                        ))
                      ) : (
                        <MenuItem disabled>Loading DB Type...</MenuItem>
                      )}
                    </Select>
                    {errors?.dbTypeName && (
                      <Typography color="error" sx={{ textAlign: "center" }}>
                        {errors?.dbTypeName}
                      </Typography>
                    )}
                  </span>

                  {(dbSeriesName === "8GB32" || dbSeriesName === "8GB30") && (
                    <>
                      <Typography sx={{ fontWeight: "bold", mt: 2 }}>
                        Variant<span style={{ color: "red" }}>*</span>
                      </Typography>
                      <span>
                        <Select
                          name="variantName"
                          disabled={userToEdit.editStdMlfb}
                          value={formData.VariantsId}
                          onChange={varientDropDownChange}
                          displayEmpty
                          fullWidth
                          input={<BootstrapInput />}
                        >
                          {varientData?.length > 0 ? (
                            varientData.map((data) => (
                              <MenuItem
                                key={data.variantId}
                                value={data.variantId}
                              >
                                {data.variantName}
                              </MenuItem>
                            ))
                          ) : (
                            <MenuItem disabled>Loading Varient...</MenuItem>
                          )}
                        </Select>
                        {errors?.variantName && (
                          <Typography
                            color="error"
                            sx={{ textAlign: "center" }}
                          >
                            {errors?.variantName}
                          </Typography>
                        )}
                      </span>
                    </>
                  )}

                  {dbSeriesName === "8GB0" &&
                    dbTypeName !== "5-TPN" &&
                    dbTypeName !== "2-SPN" &&
                    isEdit &&
                    dbTypeName !== "5-Phase Segregated" && (
                      <>
                        <span>
                          <Typography sx={{ fontWeight: "bold", mt: 2 }}>
                            Horizontal/Vertical
                            <span style={{ color: "red" }}>*</span>
                          </Typography>
                          <Select
                            name="horiVerticalName"
                            disabled={userToEdit.editStdMlfb}
                            value={formData.horiVerticalId}
                            onChange={horiVerticalDropDownChange}
                            displayEmpty
                            fullWidth
                            input={<BootstrapInput />}
                          >
                            <MenuItem value={1}>Vertical</MenuItem>
                            <MenuItem value={2}>Horizontal</MenuItem>
                          </Select>
                          {errors?.horiVerticalName && (
                            <Typography
                              color="error"
                              sx={{ textAlign: "center" }}
                            >
                              {errors?.horiVerticalName}
                            </Typography>
                          )}
                        </span>
                      </>
                    )}
                  {(dbSeriesName == "8GB0" ||
                    dbSeriesName == "8GB31" ||
                    dbSeriesName === "8GB32" ||
                    dbSeriesName === "8GB30") &&
                    dbTypeName != "5-Phase Segregated" && (
                      <>
                        <Typography sx={{ fontWeight: "bold", mt: 2 }}>
                          Country of origin
                          <span style={{ color: "red" }}>*</span>
                        </Typography>

                        <Select
                          name="countryName"
                          disabled={userToEdit.editStdMlfb}
                          value={formData.CountriesId}
                          onChange={countryDropDownChange}
                          fullWidth
                          input={<BootstrapInput />}
                        >
                          {countryData?.length > 0 ? (
                            countryData.map((data) => (
                              <MenuItem
                                key={data.countryId}
                                value={data.countryId}
                              >
                                {data.countryName}
                              </MenuItem>
                            ))
                          ) : (
                            <MenuItem disabled>Loading countries...</MenuItem>
                          )}
                        </Select>
                      </>
                    )}

                  {dbSeriesName != "" && (
                    <>
                      <Typography sx={{ fontWeight: "bold", mt: 2 }}>
                        No of ways<span style={{ color: "red" }}>*</span>
                      </Typography>
                      <span>
                        <Select
                          name="NoOfWays"
                          disabled={userToEdit.editStdMlfb}
                          value={formData.NoOfWaysId}
                          onChange={noOfWaysDropDownChange}
                          displayEmpty
                          fullWidth
                          input={<BootstrapInput />}
                        >
                          {noOfWayData?.length > 0 ? (
                            noOfWayData.map((data) => (
                              <MenuItem
                                key={data.noOfWaysId}
                                value={data.noOfWaysId}
                              >
                                {data.noOfWaysName}
                              </MenuItem>
                            ))
                          ) : (
                            <MenuItem disabled>Loading No Of Ways...</MenuItem>
                          )}
                        </Select>
                        {errors?.noOfWaysName && (
                          <Typography
                            color="error"
                            sx={{ textAlign: "center" }}
                          >
                            {errors?.noOfWaysName}
                          </Typography>
                        )}
                      </span>
                    </>
                  )}
                </Box>

                <Box sx={{ width: "45%" }}>
                  <TextField

                    className="name_wrapper "
                    id="outlined-basic"
                    label="MLFB"
                    name="txtMLFB"
                    disabled={true}
                    value={formData.txtMLFB}
                    variant="outlined"
                    onChange={handleChange}
                    fullWidth
                    //required
                    sx={{
                      width: "100%",
                      margin: "7px",
                      padding: "5px",
                      backgroundColor: userToEdit.editStdMlfb ? '#EBF7F8' : "transparent",
                      borderRadius: "4px",
                      boxSizing: "border-box"
                      // "& .MuiFormLabel-asterisk": { color: "red" },
                    }}
                  />
                  {errors?.txtMLFB && (
                    <Typography color="error" sx={{ textAlign: "center" }}>
                      {errors?.txtMLFB}
                    </Typography>
                  )}

                  <TextField
                    className="name_wrapper "
                    id="outlined-basic"
                    label="Description"
                    name="txtDescription"
                    value={formData.txtDescription}
                    variant="outlined"
                    onChange={handleChange}
                    fullWidth
                    required
                    sx={{
                      minWidth: "auto",
                      margin: "5px",
                      padding: "5px",
                      "& .MuiFormLabel-asterisk": { color: "red" },
                    }}
                  />
                  {errors?.txtDescription && (
                    <Typography color="error" sx={{ textAlign: "center" }}>
                      {errors?.txtDescription}
                    </Typography>
                  )}

                  <span>
                    <TextField
                      className="name_wrapper "
                      id="outlined-basic"
                      label="Item No"
                      name="txtItemNO"
                      value={formData.txtItemNO}
                      variant="outlined"
                      onChange={handleChange}
                      fullWidth
                      required
                      sx={{
                        minWidth: "auto",
                        margin: "5px",
                        padding: "5px",
                        "& .MuiFormLabel-asterisk": { color: "red", mt: 2 },
                      }}
                    />
                    {errors?.txtItemNO && (
                      <Typography color="error" sx={{ textAlign: "center" }}>
                        {errors?.txtItemNO}
                      </Typography>
                    )}
                  </span>
                  <span>
                    <TextField
                      className="name_wrapper "
                      id="outlined-basic"
                      label="Drawing No"
                      name="txtDrawingNo"
                      value={formData.txtDrawingNo || ""}
                      variant="outlined"
                      onChange={handleChange}
                      fullWidth
                      sx={{
                        minWidth: "auto",
                        margin: "5px",
                        padding: "5px",
                      }}
                    />
                  </span>
                  <span>
                    <TextField
                      className="name_wrapper "
                      id="outlined-basic"
                      label="Cost"
                      name="txtCost"
                      value={formData.txtCost || ""}
                      variant="outlined"
                      onChange={handleChange}
                      fullWidth
                      sx={{
                        minWidth: "auto",
                        margin: "5px",
                        padding: "5px",
                      }}
                    />
                    {errors?.txtCost && (
                      <Typography color="error" sx={{ textAlign: "center" }}>
                        {errors?.txtCost}
                      </Typography>
                    )}
                  </span>

                  <span>
                    <TextField
                      className="name_wrapper "
                      id="outlined-basic"
                      label="MRP"
                      name="txtMRP"
                      value={formData.txtMRP || ""}
                      variant="outlined"
                      onChange={handleChange}
                      fullWidth
                      required
                      sx={{
                        minWidth: "auto",
                        margin: "5px",
                        padding: "5px",
                        "& .MuiFormLabel-asterisk": { color: "red", mt: 2 },
                      }}
                    />
                    {errors?.txtMRP && (
                      <Typography color="error" sx={{ textAlign: "center" }}>
                        {errors?.txtMRP}
                      </Typography>
                    )}
                  </span>
                </Box>
              </Box>

              {/* {error && (
                <Typography color="error" sx={{ mt: 2, textAlign: "center" }}>
                  {error}
                </Typography>
              )} */}
            </DialogContent>

            <DialogActions sx={{ justifyContent: "center", pb: 3 }}>
              {/* {userToEdit?.editStdMlfb && (
                <Button
                  className="btn"
                  onClick={() => onPreview(MLFBId)}
                  variant="contained"
                  color="primary"
                  sx={{ width: "120px", ml: 2 }}
                >
                  Preview Drawing
                </Button>
              )} */}
              <Button
                className="btn"
                onClick={handleSave}
                variant="contained"
                color="primary"
                sx={{ width: "120px", ml: 2 }}
              >
                {userToEdit?.editStdMlfb ? "Update" : "Save"}
              </Button>
              {/* <div> */}
              {userToEdit?.editStdMlfb && (
                <Button
                  className="btn"
                  onClick={handleDrawing}
                  variant="contained"
                  color="primary"
                  sx={{ width: "120px", ml: 2 }}
                >
                  Upload Drawing
                </Button>
              )}
              <UploadDrawingDialog
                open={openDialog}
                onClose={() => setOpenDialog(false)}
                onUpload={onUploadDrawing}
              />
              {/* </div> */}
            </DialogActions>
            <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
              <FormControlLabel
                control={
                  <Checkbox
                    style={{ color: "#1976d2", left: "28px", bottom: "56px" }}
                    checked={checkedIn}
                    onChange={handleCheckChange}
                  />
                }
              />
              <Typography
                sx={{
                  mt: 2,
                  textAlign: "center",
                  position: "relative",
                  top: "-61px",
                }}
              >
                Is Active
              </Typography>
            </Box>
          </Dialog>
          {loaderUploading ? <Loading /> : <></>}
        </div>
      </>
    );
  }
);

export default standardMlfbDialog;
